export default __webpack_public_path__ + "static/media/img--design-2.ffe8ace7.jpg";